import { useEffect, useRef } from "react";
import { AppState } from "react-native";

import { shouldCheckForUpdate } from "./update-check";
import { checkAndDownloadUpdate } from "./useAppUpdates";

/**
 * Renders nothing. While mounted it re-checks for (and silently downloads) an update when the app
 * returns to the foreground, throttled. It never reloads on its own, so a downloaded update applies
 * on the next cold start or when the user taps "Restart" in the version panel.
 */
export function AppLifecycle() {
  const lastCheckedAt = useRef<number | null>(null);

  useEffect(() => {
    // The launch-time check already ran in the startup gate, so only re-check on later foregrounds.
    lastCheckedAt.current = Date.now();
    const subscription = AppState.addEventListener("change", (state) => {
      if (state !== "active") return;
      const now = Date.now();
      if (!shouldCheckForUpdate(lastCheckedAt.current, now)) return;
      lastCheckedAt.current = now;
      void checkAndDownloadUpdate();
    });
    return () => subscription.remove();
  }, []);

  return null;
}
